import React, { ComponentType, CSSProperties, ReactNode } from 'react';

import { PaletteColor } from '@utils/types';
import CustomIcon from '@components/utils/CustomIcon';

import {
  AnimationItem,
  AnimationItemDetail,
  Animations,
  Wrapper,
  Text,
  Container,
  AnimationValue,
  ContainerAnimation,
  BadgeAnimationWrapper,
} from './style';

export interface IconLabelProps {
  icon?: ComponentType<React.PropsWithChildren<unknown>>;
  iconLocation?: 'left' | 'right';
  iconSize?: number;
  iconColor?: PaletteColor;
  backgroundColor?: PaletteColor;
  width?: number;
  tooltipText?: string | ReactNode;
  color?: PaletteColor;
  textStyle?: CSSProperties;
  className?: string;
  description?: string;
  roomCard?: boolean;
  badgeText?: string;
  badgeAnimation?: { key: number; value: string }[];
  animationWidth?: number;
  animationHeight?: number;
  detail?: boolean;
}

const IconLabel = ({
  color = 'black',
  width,
  backgroundColor = 'white',
  textStyle,
  iconLocation = 'left',
  className,
  badgeAnimation = [],
  iconSize,
  icon,
  iconColor,
  animationHeight,
  animationWidth,
  detail,
}: IconLabelProps) => {
  // Conditionally check if the animation should be applied
  const shouldAnimate = badgeAnimation.length > 1;

  return (
    <>
      {badgeAnimation.length > 0 ? (
        <Wrapper
          animationHeight={animationHeight}
          animationWidth={animationWidth}
          width={width}
          className={className}
          backgroundColor={backgroundColor}
          iconLocation={iconLocation}
        >
          <Text detail={detail} style={textStyle} color={color}>
            {shouldAnimate ? (
              <>
                {detail ? (
                  <Animations>
                    {badgeAnimation.map((item) => (
                      <AnimationItemDetail
                        animationHeight={animationHeight}
                        key={item.key}
                      >
                        <Container>
                          <CustomIcon
                            fontSize={iconSize}
                            icon={icon}
                            paletteColor={iconColor}
                          />
                          <AnimationValue>{item.value}</AnimationValue>
                        </Container>
                      </AnimationItemDetail>
                    ))}
                  </Animations>
                ) : (
                  <Animations>
                    {badgeAnimation.map((item) => (
                      <AnimationItem
                        animationHeight={animationHeight}
                        key={item.key}
                      >
                        <ContainerAnimation>
                          <CustomIcon
                            fontSize={iconSize}
                            icon={icon}
                            paletteColor={iconColor}
                          />
                          <AnimationValue>{item.value}</AnimationValue>
                        </ContainerAnimation>
                      </AnimationItem>
                    ))}
                  </Animations>
                )}
              </>
            ) : (
              badgeAnimation.length === 1 && (
                <BadgeAnimationWrapper>
                  <CustomIcon
                    fontSize={iconSize}
                    icon={icon}
                    paletteColor={iconColor}
                  />
                  {badgeAnimation[0].value}
                </BadgeAnimationWrapper>
              )
            )}
          </Text>
        </Wrapper>
      ) : null}
    </>
  );
};

export default IconLabel;
